import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
/**
 * External dependencies
 */

import TextareaAutosize from 'react-autosize-textarea';
import classnames from 'classnames';
/**
 * @see https://github.com/WordPress/gutenberg/blob/master/packages/block-editor/src/components/plain-text/README.md
 */

var PlainText = forwardRef(function (_ref, ref) {
  var _onChange = _ref.onChange,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["onChange", "className"]);

  return createElement(TextareaAutosize, _extends({
    ref: ref,
    className: classnames('editor-plain-text block-editor-plain-text', className),
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  }, props));
});
export default PlainText;
//# sourceMappingURL=index.js.map